import mitt from "mitt";
var emitter = mitt();
export default emitter;